import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '';

/**
 * SSOLogin — handles auto-login from Payd portal.
 * URL: /sso?token=<signed_jwt>
 * 
 * Flow:
 * 1. Extract token from query string
 * 2. POST to /api/auth/sso/token to exchange it for a Railway JWT
 * 3. Store Railway JWT + user in localStorage (same as normal login)
 * 4. Redirect to /dashboard
 */
const SSOLogin = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('Authenticating...');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ssoToken = params.get('token');

    if (!ssoToken) {
      window.location.replace('/');
      return;
    }

    const doSSO = async () => {
      try {
        setStatus('Verifying your Payd credentials...');
        const response = await axios.post(
          `${API_BASE}/api/auth/sso/token`,
          { sso_token: ssoToken },
          { withCredentials: true }
        );

        const { token, user } = response.data;

        // Store exactly the same way as normal login
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
        setStatus('Redirecting to leaderboard...');
        // Small delay so the user sees the success state
        setTimeout(() => {
          navigate('/dashboard', { replace: true });
        }, 400);
      } catch (err) {
        console.error('[SSO] Error:', err);
        window.location.replace('/');
      }
    };

    doSSO();
  }, [navigate]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: '#f8fafc',
      fontFamily: 'system-ui, sans-serif',
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 12,
        padding: '40px 48px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
        textAlign: 'center',
        maxWidth: 400,
      }}>
        {/* EIP logo placeholder */}
        <div style={{ fontSize: 40, marginBottom: 16 }}>🏆</div>
        <h2 style={{ margin: '0 0 8px', color: '#1a202c', fontSize: 22 }}>EIP Leaderboard</h2>

        <>
          <p style={{ color: '#4a5568', margin: '16px 0 0', fontSize: 15 }}>{status}</p>
          <div style={{ marginTop: 20 }}>
            <div style={{
              width: 32, height: 32, border: '3px solid #e2e8f0',
              borderTopColor: '#48bb78', borderRadius: '50%',
              animation: 'spin 0.8s linear infinite',
              margin: '0 auto',
            }} />
          </div>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </>
      </div>
    </div>
  );
};

export default SSOLogin;
